import setPromiseState from '../../utils/promiseState';
import actionTypes from './ActionTypes';
import InitState from './InitState';

export default (state = InitState, actions) => {
  switch (actions.type) {

    case actionTypes.CHANGE_CART:
      return {...state, list: actions.data || []};

    case actionTypes.CHANGE_CART_ERROR:
      return {...state, error: {...state.error, differentCity: actions.data}};

    case actionTypes.GET_CART_TOURS.pending:
      return {...state, promise: {...state.promise, getCartTours: {...setPromiseState(true, false, false)}}};
    case actionTypes.GET_CART_TOURS.rejected:
      return {...state, error: actions.data || {}, promise: {...state.promise, getCartTours: {...setPromiseState(false, false, true)}}};
    case actionTypes.GET_CART_TOURS.fulfilled: {
      return {
        ...state,
        toursList: actions.data || [],
        list: actions.list || [],
        promise: {...state.promise, getCartTours: {...setPromiseState(false, true, false)}}};
    }

    case actionTypes.CLEAR_CART:
      return {
        ...state,
        list: [],
        toursList: [],
        metingPlace: ''
      };

    case actionTypes.SET_METING_PLACE:
      return {...state, metingPlace: actions.data};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/Cart/Reducer.js